import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-product zoom" }
const _hoisted_2 = { class: "img-area" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-area" }
const _hoisted_5 = { class: "title secondary-font" }
const _hoisted_6 = { class: "price secondary-font" }

import { inject } from 'vue';
import { formatAmount } from '@/utils/formatters';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCardProduct',
  props: {
    produit: { type: Object, required: true },
    layout: { type: String, default: 'none' },
},
  setup(__props) {

// @ts-expect-error raison: lib externe mal typée
const BACKEND_URL = inject('BACKEND_URL');
const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"tag-set justify-content-end\"><div class=\"tag2\">-20%</div></div><div class=\"btn-set\"><button class=\"btn-ultra lg btn-panier\"><div class=\"btn-show\"><img src=\"/public/icons/icon-panier.svg\" class=\"btn-icon\" alt=\"\"></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div>", 2)),
      _createVNode(_component_router_link, {
        to: (__props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id,
        style: {"height":"290px","display":"flex","justify-content":"center","align-items":"center","padding":"20px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + props.produit.image,
            class: "img",
            style: {"max-width":"80%","max-height":"100%"}
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_router_link, {
      to: (__props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(props.produit.nom), 1),
          _createElementVNode("h3", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(formatAmount)(props.produit.montant)) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "secondary-font" }, "F", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})